angular.module('impactx.autoComplete').directive('ixAsyncAutocomplete', function () {
    return {
        scope: {
            entryPoint: "@",
            getEntriesFunc: "&",
            selected: "=",
            showMust: "=",
            name: "@",
            label: "@",
            dialogData: "=",
            readonly: "=",
            onSelect: "&",
            onSearchTextChange: "&",
            baseObject: "=",
            hiddenId: "=",
            additionalDataArray: "=",
            usePost: "=",
            selectOnFocus: '=',
            noMatchRequired: "=",
            minLength: "=?",
            getEntriesControl: "=",
            itemTemplate: "=",
            modifyItemText: '&?',
            maxLength: '=?',
            hideClear: "=",
            selectIfOne: "=",
            dropDownItems: "=",
            cannotSelectReadOnlyItems: "=",
            readOnlyLabel: "@",
            additionalInfo: "@",
            errorMessage: "@",
            showSecondValue: "=",
            showEntryTooltip: "=?"
        },
        restrict: 'E',
        controller: 'AsyncAutocompleteCtrl',
        controllerAs: 'asyncAutocompleteCtrl',
        templateUrl: 'shared/autocomplete/templates/asyncautocomplete.tmpl.html',
        compile: function (element, attributes) {
            if (attributes.selectOnFocus == 'true') {
                var autocompleteElement = element.find('md-autocomplete');
                if (autocompleteElement) {
                    autocompleteElement.attr('md-select-on-focus', 'true');
                }
            }
        }
    }
});
